'use client'
import { FC } from 'react'
import { SelectedNetworkContinueButton } from './selected-network-continue-button'
import { NetworkBasicInfo } from './types'

interface SelectedNetworkFooterProps {
  selectedNetwork?: NetworkBasicInfo
}

export const SelectedNetworkFooter: FC<SelectedNetworkFooterProps> = ({
  selectedNetwork
}) => {
  return (
    <div className="mt-4 flex flex-col gap-2 rounded-md bg-slate-100 px-4 py-3 md:flex-row md:items-center md:justify-between">
      <div className="text-sm">
        {selectedNetwork ? (
          <>
            <p className="font-semibold">{selectedNetwork.title}</p>
            <p className="break-words text-gray-500">{`yellowdig.app/n/${selectedNetwork.name.toLowerCase()}`}</p>
          </>
        ) : (
          <p className="font-semibold">Select your institution to continue</p>
        )}
      </div>
      <SelectedNetworkContinueButton selectedNetwork={selectedNetwork} />
    </div>
  )
}
